var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"layout":_vm.layout,"control_states":_vm.control_states},on:{"layout":e => _vm.$emit('layout', e),"controlStates":(e) => _vm.control_states = e,"letterKey":_vm.onLetterKey,"funcKey":_vm.onFunctionalKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }